import { render, staticRenderFns } from "./SummariesList.vue?vue&type=template&id=1cbbc878"
import script from "./SummariesList.vue?vue&type=script&lang=js"
export * from "./SummariesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports